import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Grid from 'packages/ui/Grid';
import { Formik, Field, Form } from 'formik';
import { FormControl, FormGroup, Label } from 'components/form/Formik';
import DescriptionInput from './DescriptionInput';
import UTMInput from './UTMInput';
import SmsLineInput from './SmsLine';
import { DatePicker } from 'jalali-react-datepicker';
import moment from 'moment';
import Button from 'packages/ui/Button';

function CampaignForm({ initialValues, onSubmit, submitButtonText }) {
  const [sendDateTime, setSendDateTime] = useState(
    initialValues.send_date
      ? moment(initialValues.send_date).format('YYYY-MM-DD HH:mm:ss')
      : moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
  );
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (data, actions) => {
        actions.setSubmitting(true);
        return onSubmit({
          channel: data.channel,
          subject: data.subject,
          sender_name: data.sender_name,
          event_id: data.event_id,
          discount_code: data.discount_code,
          utm: data.channel === 'email' ? data.emailUtm : data.smsUtm,
          send_date: sendDateTime,
          maximum_intended_receivers: data.maximum_intended_receivers,
          description:
            data.channel === 'sms'
              ? data.description_sms.replace(/<\/?[^>]+(>|$)/g, '').replace(/&nbsp;/g, ' ')
              : data.description,
          sms_line: data.channel === 'sms' ? data.sms_line : '',
          file_id: data.file_id
        });
      }}
    >
      {({ values, setFieldValue, isSubmitting }) => {
        return (
          <Form>
            <FormGroup>
              <Label htmlFor="refundable_type">کانال ارتباطی</Label>
              <FormControl>
                <Field as="select" name="channel">
                  <option value="email">ایمیل</option>
                  <option value="sms">پیامک</option>
                  <option value="bale">بله</option>
                </Field>
              </FormControl>
            </FormGroup>

            <FormGroup>
              <Label htmlFor="subject">عنوان</Label>
              <FormControl>
                <Field id="subject" name="subject" placeholder="" type="text" />
              </FormControl>
            </FormGroup>

            <FormGroup>
              <Label htmlFor="file-id">شناسه فایل</Label>
              <FormControl>
                <Field id="file-id" name="file_id" placeholder="" type="text" />
              </FormControl>
            </FormGroup>

            <DescriptionInput values={values} setFieldValue={setFieldValue} />

            <FormGroup>
              <Label htmlFor="sender_name">نام فرستنده</Label>
              <FormControl>
                <Field
                  id="sender_name"
                  name="sender_name"
                  placeholder=""
                  type="text"
                  help="در صورتی که نام فرستنده را وارد نکنید از اسم سازمان برگزارکننده استفاده خواهد شد"
                />
              </FormControl>
            </FormGroup>

            <Grid md={2}>
              <FormGroup>
                <Label htmlFor="event_id">کد رویداد</Label>
                <FormControl>
                  <Field
                    id="event_id"
                    name="event_id"
                    placeholder=""
                    type="text"
                    textDirection="ltr"
                  />
                </FormControl>
              </FormGroup>
              <FormGroup>
                <Label htmlFor="discount_code">کد تخفیف</Label>
                <FormControl>
                  <Field
                    id="discount_code"
                    name="discount_code"
                    placeholder=""
                    type="text"
                    textDirection="ltr"
                  />
                </FormControl>
              </FormGroup>
            </Grid>

            <UTMInput />

            <Grid md={2}>
              <FormGroup>
                <Label htmlFor="send_date">زمان ارسال</Label>
                <FormControl>
                  <DatePicker
                    value={moment(initialValues.send_date)}
                    onClickSubmitButton={e => {
                      var dateStringWithTime = moment(e.value._d).format('YYYY-MM-DD HH:mm:ss');
                      setSendDateTime(dateStringWithTime);
                    }}
                  />
                </FormControl>
              </FormGroup>

              <FormGroup>
                <Label htmlFor="maximum_intended_receivers">تعداد دریافت‌کنندگان</Label>
                <FormControl>
                  <Field
                    id="maximum_intended_receivers"
                    name="maximum_intended_receivers"
                    placeholder=""
                    type="number"
                    min={1}
                    textDirection="ltr"
                  />
                </FormControl>
              </FormGroup>
            </Grid>

            <SmsLineInput sms={values.channel === 'sms'} />

            <Button type="submit" disabled={isSubmitting}>
              {submitButtonText}
            </Button>
          </Form>
        );
      }}
    </Formik>
  );
}

CampaignForm.propTypes = {
  initialValues: PropTypes.object,
  name: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string.isRequired
};

export default CampaignForm;
